<template>
  <div class="detail-payment-pages px-4 py-5">
    <div class="id-card-info" style="padding-bottom: 150px">
      <loading :show-loading="showLoading" />
      <h3 v-if="imgCCCD" class="mb-3 font-size-18 fw-bold">
        {{ $t("esim_id_card_information") }}
      </h3>
      <h3 v-else class="mb-3 font-size-18 fw-bold">
        {{ $t("esim_passport_information") }}
      </h3>
      <div class="mb-3">
        <van-cell-group class="list-detail-payment">
          <van-cell class="">
            <template #title>{{ $t("esim_id_number") }}:
              <span class="text-danger">*</span></template>
            <template #value>{{ data.idNumber }} </template>
          </van-cell>
          <van-cell class="">
            <template #title>{{ $t("esim_full_name") }}:
              <span class="text-danger">*</span></template>
            <template #value>
              <p class="mb-0 text-uppercase">{{ data.fullName }}</p>
            </template>
          </van-cell>
          <van-cell class="">
            <template #title>{{ $t("esim_gender") }}: <span class="text-danger">*</span>
            </template>
            <template #value>{{ data.gender }} </template>
          </van-cell>
          <van-cell class="">
            <template #title>{{ $t("esim_dob") }}:
              <span class="text-danger">*</span></template>
            <template #value>{{ data.dob }} </template>
          </van-cell>
          <van-cell class="" v-if="data.province">
            <template #title>{{ $t("esim_province") }}:
              <span class="text-danger">*</span></template>
            <template #value>{{ data.province }}</template>
          </van-cell>
          <van-cell class="" v-if="data.nationality">
            <template #title>{{ $t("esim_nationality") }}:
              <span class="text-danger">*</span></template>
            <template #value>{{ data.nationality }}</template>
          </van-cell>
        </van-cell-group>
      </div>
      <div class="">
        <van-divider :style="{ borderColor: '#000' }"></van-divider>
        <van-row class="justify-content-center">
          <van-col span="12" v-if="data.imgCCCD && idType == 1">
            <div class="d-flex flex-column justify-content-center align-items-center gap-2">
              <img :src="data.imgCCCD" alt="ID Card picture" class="img-id-card"
                :class="statusCCCD ? 'border-success' : 'border-danger'" />
              <van-icon v-if="statusCCCD" name="checked" color="#00BA00" size="26" />
              <van-icon v-else name="clear" color="#F74750" size="26" />
              <p class="mb-0" :style="{ color: '#10716D' }">
                {{ $t("esim_id_card_picture") }}
              </p>
            </div>
          </van-col>
          <van-col span="12" v-if="data.imgPassport && idType == 3">
            <div class="d-flex flex-column justify-content-center align-items-center gap-2">
              <img :src="data.imgPassport" alt="ID Card picture" class="img-id-card"
                :class="statusPassport ? 'border-success' : 'border-danger'" />
              <van-icon v-if="statusPassport" name="checked" color="#00BA00" size="26" />
              <van-icon v-else name="clear" color="#F74750" size="26" />
              <p class="mb-0" :style="{ color: '#10716D' }">
                {{ $t("esim_passport_picture") }}
              </p>
            </div>
          </van-col>
          <van-col span="12" v-if="data.imgVisa && idType == 3">
            <div class="d-flex flex-column justify-content-center align-items-center gap-2">
              <img :src="data.imgVisa" alt="ID Card picture" class="img-id-card"
                :class="statusVisa ? 'border-success' : 'border-danger'" />
              <van-icon v-if="statusVisa" name="checked" color="#00BA00" size="26" />
              <van-icon v-else name="clear" color="#F74750" size="26" />
              <p class="mb-0" :style="{ color: '#10716D' }">
                {{ $t("esim_visa_picture") }}
              </p>
            </div>
          </van-col>
          <van-col span="12" v-if="data.imgFaceId">
            <div class="d-flex flex-column justify-content-center align-items-center gap-2">
              <img :src="data.imgFaceId" alt="ID Card picture" class="img-faceid"
                :class="statusFaceId ? 'border-success' : 'border-danger'" />
              <van-icon v-if="statusFaceId" name="checked" color="#00BA00" size="26" />
              <van-icon v-else name="clear" color="#F74750" size="26" />
              <p class="mb-0" :style="{ color: '#10716D' }">
                {{ $t("esim_portrait") }}
              </p>
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="fixed-bottom w-100">
      <div class="p-4">
        <van-divider :style="{ borderColor: '#000' }"></van-divider>
        <template v-if="isShowPay">
          <van-button @click="handlePreBuyEsimABA(1)"
            class="btn btn-primary rounded-3 shadown-primary text-uppercase shadow-1" block>
            {{ $t("esim_continue") }}
          </van-button>
        </template>
        <template v-else>
          <van-button @click="handlePreBuyEsimABA(0)"
            class="btn btn-primary rounded-3 shadown-primary text-uppercase shadow-1" block>
            {{ $t("esim_try_again") }}
          </van-button>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  Divider,
  CellGroup,
  SubmitBar,
  FloatingPanel,
  Row,
  Cell,
  Col,
} from "vant";
import { formatToDateDDMMYYYY } from "@/ultis/dateFormat";
import { CONSTANTS } from "@/helpers/constants";
import { ESIM_ORDER_FLOW } from "@/helpers/esimFlow";
import { encrypt, sign, keyToPem } from "anhdev99.rsa";
import Loading from "@/components/loading";

export default {
  name: "Detail",
  // props: {
  //     itemCCCD: {
  //         type: Object,
  //         required: false,
  //     },
  //     itemPassport: {
  //         type: Object,
  //         required: false,
  //     },
  //     itemVisa: {
  //         type: Object,
  //         required: false,
  //     },
  //     itemFaceId: {
  //         type: Object,
  //         required: false,
  //     },
  //     imgCCCD: {
  //         type: String,
  //         required: false,
  //     },
  //     imgFaceId: {
  //         type: String,
  //         required: true,
  //     },
  //     imgPassport: {
  //         type: String,
  //         required: false,
  //     },
  //     imgVisa: {
  //         type: String,
  //         required: false,
  //     },
  // },
  components: {
    [Divider.name]: Divider,
    [CellGroup.name]: CellGroup,
    [SubmitBar.name]: SubmitBar,
    [FloatingPanel.name]: FloatingPanel,
    [Row.name]: Row,
    [Cell.name]: Cell,
    [Col.name]: Col,
    Loading,
  },
  data() {
    return {
      lang: "",
      data: {
        idNumber: "",
        fullName: "",
        gender: "",
        dob: "",
        province: "",
        nationality: "",
        imgCCCD: "",
        imgPassport: "",
        imgVisa: "",
        imgFaceId: "",
      },
      statusCCCD: false,
      statusPassport: false,
      statusVisa: false,
      statusFaceId: false,
      imes: {
        isdn: "",
        idNumber: "",
        accountABA: "",
        fullName: "",
        dob: "",
        packageCode: "",
        packageName: "",
        packagePrice: "",
        isdnPrice: "",
        transIdeKYC: "",
        totalAmount: "",
        orderCode: "",
      },
      idType: 0,
      base64ImgCCCD: "",
      base64ImgPassport: "",
      base64ImgVisa: "",
      base64ImgFaceId: "",
      isEkyc: "",
      isShowPay: false,
      showLoading: false,
    };
  },
  computed: {
    ...mapState("userStore", ["profile", "defaultParam"]),
    ...mapState("esimBuyStore", ["orderDetail", "detailPaymentInfo"]),
    ...mapState("headerStore", ["title"]),
    ...mapState("verificationInfoStore", ["itemCCCDStore", "imgCCCDStore"]),
    ...mapState("verificationInfoStore", [
      "itemPassportStore",
      "imgPassportStore",
    ]),
    ...mapState("verificationInfoStore", ["imgVisaStore"]),
    ...mapState("verificationInfoStore", ["itemFaceIdStore", "imgFaceIdStore"]),
  },
  created() {
    console.log("itemCCCD", this.itemCCCDStore);
    console.log("itemPassport", this.itemPassportStore);
    console.log("itemFaceId", this.itemFaceIdStore);

    this.itemCCCD = this.itemCCCDStore ? this.itemCCCDStore : null;
    this.imgCCCD = this.imgCCCDStore ? this.imgCCCDStore : null;

    this.itemPassport = this.itemPassportStore ? this.itemPassportStore : null;
    this.imgPassport = this.imgPassportStore ? this.imgPassportStore : null;

    this.imgVisa = this.imgVisaStore ? this.imgVisaStore : null;

    this.itemFaceId = this.itemFaceIdStore ? this.itemFaceIdStore : null;
    this.imgFaceId = this.imgFaceIdStore ? this.imgFaceIdStore : null;

    this.lang = this.profile ? this.profile.lang : "en";
    // CCCD
    if (this.itemCCCD && this.idType == 1) {
      if (this.lang === "km") {
        this.data.idNumber = this.itemCCCD.idCardInfo.idNumber;
        this.data.fullName = this.itemCCCD.idCardInfo.name;
        this.data.gender = this.itemCCCD.idCardInfo.khSex;
        this.data.dob = this.itemCCCD.idCardInfo.khDob;
        this.data.province = this.itemCCCD.idCardInfo.khProvince;
      } else {
        this.data.idNumber = this.itemCCCD.idCardInfo.idNumber;
        this.data.fullName = this.itemCCCD.idCardInfo.name;
        this.data.gender = this.itemCCCD.idCardInfo.enSex;
        this.data.dob = this.itemCCCD.idCardInfo.enDob;
        this.data.province = this.itemCCCD.idCardInfo.enProvince;
      }
      this.data.imgCCCD = this.imgCCCD ? this.imgCCCD : "";

      if (this.itemCCCD.errorCode == 0) {
        if (this.itemCCCD.idCardInfo.isFraud == "false") {
          this.statusCCCD = true;
        } else {
          this.statusCCCD = false;
        }
      } else {
        this.statusCCCD = false;
      }

      if (this.itemFaceId) {
        if (this.itemFaceId.errorCode == 0) {
          if (this.itemFaceId.face.isFraud == "false") {
            if (this.itemFaceId.face.match == "true") {
              this.statusFaceId = true;
            } else {
              this.statusFaceId = false;
            }
          } else {
            this.statusFaceId = false;
          }
        }
      } else {
        this.statusFaceId = false;
      }
    }

    // Passport
    if (this.itemPassport && this.idType == 3) {
      if (this.lang === "km") {
        this.data.idNumber = this.itemPassport.passportInfo.documentNum;
        this.data.fullName =
          this.itemPassport.passportInfo.surname +
          " " +
          this.itemPassport.passportInfo.givenName;
        this.data.gender =
          this.itemPassport.passportInfo.sex === "M" ? "Male" : "Female";
        this.data.dob = this.itemPassport.passportInfo.birthday;
        this.data.province = "";
        this.data.nationality = this.itemPassport.passportInfo.country;
      } else {
        this.data.idNumber = this.itemPassport.passportInfo.documentNum;
        this.data.fullName =
          this.itemPassport.passportInfo.surname +
          " " +
          this.itemPassport.passportInfo.givenName;
        this.data.gender =
          this.itemPassport.passportInfo.sex === "M" ? "Male" : "Female";
        this.data.dob = this.itemPassport.passportInfo.birthday;
        this.data.province = "";
        this.data.nationality = this.itemPassport.passportInfo.country;
      }

      this.data.imgPassport = this.imgPassport ? this.imgPassport : "";
      this.data.imgVisa = this.imgVisa ? this.imgVisa : "";

      if (this.itemPassport.errorCode == 0) {
        this.statusPassport = true;
      } else {
        this.statusPassport = false;
      }

      this.statusVisa = this.imgVisa ? true : false;
      if (this.itemFaceId) {
        if (this.itemFaceId.errorCode == 0) {
          if (this.itemFaceId.face.isFraud == "false") {
            if (this.itemFaceId.face.match == "true") {
              this.statusFaceId = true;
            } else {
              this.statusFaceId = false;
            }
          } else {
            this.statusFaceId = false;
          }
        }
      } else {
        this.statusFaceId = false;
      }
    }

    this.data.imgFaceId = this.imgFaceId ? this.imgFaceId : "";

    this.checkStatusCallApiPre();
  },
  mounted() {
    this.changeTitle(this.$t("esim_register_info"));
  },
  watch: {
    $route: {
      handler: function (value) {
        this.$store.dispatch("headerStore/setTitle", "esim_register_info");
      },
      immediate: true,
    },
    "$route.hash": {
      handler: function (id_card) {
        console.log("id_card", id_card);
        if (id_card == "#id-card") {
          this.idType = 1;
        } else if (id_card == "#passport") {
          this.idType = 3;
        }
      },
      immediate: true,
    },
  },
  methods: {
    color_primary() {
      return CONSTANTS.color_primary;
    },

    changeTitle(title) {
      const contentData = {
        title: title,
        color: "#ffffff",
        bgColor: this.color_primary(),
      };
      this.$bridge.callHandler("setBarTitle", contentData).then((data) => { });
    },
    stateAsObject(value) {
      return JSON.parse(JSON.stringify(value));
    },
    formatToDateDDMMYYYY,

    checkStatusCallApiPre() {
      if (
        (this.itemCCCD && this.statusCCCD && this.statusFaceId) ||
        (this.itemPassport &&
          this.statusPassport &&
          this.statusVisa &&
          this.statusFaceId)
      ) {
        this.isEkyc = "true";
        this.isShowPay = true;
      } else {
        this.isEkyc = "failed";
        this.isShowPay = false;
      }
    },
    async handlePreBuyEsimABA(flag) {
      console.log("handlePreBuyEsimABA", flag, this.detailPaymentInfo?.orderCode);

      // verification-info#id-card — Try again (flag === 0):
      // - Change eSIM: chỉ điều hướng, không gọi prePaymentChangeSim / preBuy.
      // - Buy eSIM: gọi prePayment rồi điều hướng (xử lý trong nhánh dưới).
      const isIdCardTryAgain =
        flag === 0 &&
        (this.$route.hash === "#id-card" || this.idType === 1);
      if (
        isIdCardTryAgain &&
        this.orderDetail?.esimOrderFlow === ESIM_ORDER_FLOW.CHANGE
      ) {
        this.handleEKYCNavigation();
        return;
      }

      // Change-to-eSIM flow: chỉ khi vào từ ChangeToEsimMetfone (có esimOrderFlow).
      // Không dùng !esimPackageCode — buy flow dùng "" làm default và cũng falsy.
      if (
        flag === 1 &&
        this.idType === 1 &&
        this.orderDetail &&
        this.orderDetail.esimOrderFlow === ESIM_ORDER_FLOW.CHANGE
      ) {
        const paramsChange = {
          token: this.defaultParam?.token,
          locale: this.defaultParam?.locale || "en_US",
          accountABA: this.profile?.appId || "",
          isdn: this.orderDetail?.esimIsdn || "",
          idType: this.idType,
          idNumber: this.data?.idNumber || "",
          fullName: this.data?.fullName || "",
          dob: this.data?.dob || "",
        };

        this.showLoading = true;
        try {
          const res = await this.$store.dispatch(
            "esimMetfoneStore/checkMatchInfoChangeSim",
            paramsChange,
          );

          const errorCode = res?.data?.errorCode;
          const message =
            res?.data?.message || res?.message || "Unknown error";

          if (errorCode !== 0) {
            this.$notify({ code: errorCode || 1, message });
            return;
          }

          // Call prePaymentChangeSim next, then go to payment page.
          const orderCodeForMes =
            res?.data?.orderCode || this.imes?.orderCode || "";
          const isdn = this.orderDetail?.esimIsdn || "";
          const transIdeKYC = this.itemCCCD?.transid || "";

          const mes = `<data>
            <merchantAccount>MINI_APP</merchantAccount>
            <isdn>${isdn}</isdn>
            <idNumber>${this.data?.idNumber || ""}</idNumber>
            <accountABA>${this.profile?.appId || ""}</accountABA>
            <fullName>${this.data?.fullName || ""}</fullName>
            <dob>${this.data?.dob || ""}</dob>
            <transIdeKYC>${transIdeKYC}</transIdeKYC>
            <idType>${this.idType || ""}</idType>
            <orderCode>${orderCodeForMes}</orderCode>
          </data>`;

          let paramsPay = this.stateAsObject(this.defaultParam);
          delete paramsPay.env;
          paramsPay.frontSide = (this.data?.imgCCCD || "").replace(
            /^data:image\/\w+;base64,/,
            ""
          );
          paramsPay.portrait = (this.data?.imgFaceId || "").replace(
            /^data:image\/\w+;base64,/,
            ""
          );
          const privateKeyPem = keyToPem(
            CONSTANTS.PRIVATE_KEY,
            "PRIVATE KEY"
          );
          const publicKeyPem = keyToPem(
            CONSTANTS.PUBLIC_KEY,
            "PUBLIC KEY"
          );
          paramsPay.signature = sign(mes, privateKeyPem);
          paramsPay.encrypt = encrypt(mes, publicKeyPem);
          // Ensure msisdn matches isdn in this flow.
          paramsPay.msisdn = isdn;

          const resPay = await this.$store.dispatch(
            "esimMetfoneStore/prePaymentChangeSim",
            paramsPay
          );

          const errorCodePay = resPay?.data?.errorCode;
          const messagePay =
            resPay?.data?.message || resPay?.message || "Unknown error";

          if (errorCodePay !== 0) {
            this.$notify({ code: errorCodePay || 1, message: messagePay });
            return;
          }

          const result = resPay?.data || {};
          this.$store.dispatch("esimBuyStore/detailPaymentInfo", {
            flowType: ESIM_ORDER_FLOW.CHANGE,
            fullName: this.data?.fullName || "",
            gender: this.data?.gender || "",
            dob: this.data?.dob || "",
            province: this.data?.province || "",
            idNumber: this.data?.idNumber || "",
            phoneNumber: isdn,
            phoneNumberPrice: 0,
            idType: this.idType,
            orderCode: result.orderCode || "",
            requestId: result.requestId || "",
            fee: 0,
            totalAmount: Number(result.amount || 0),
            isEkyc: this.isEkyc,
            hashPayment: result.hashPayment || "",
            transIdeKYC: transIdeKYC,
          });

          this.$router.replace({ path: "/esim-payment" });
        } catch (e) {
          this.$notify({
            code: 1,
            message:
              e?.message || e?.response?.data?.message || "Unknown error",
          });
        } finally {
          this.showLoading = false;
        }
        return;
      }

      // Passport / Try again có orderCode: chỉ điều hướng. Id-card (idType 1) Try again buy: luôn gọi preBuy.
      if (
        flag == 0 &&
        this.detailPaymentInfo?.orderCode &&
        this.idType !== 1
      ) {
        this.handleEKYCNavigation();
      } else {
        if (this.defaultParam) {
          if (this.orderDetail) {
            this.imes.isdn = this.orderDetail.esimIsdn;
            this.imes.packageCode = this.orderDetail.esimPackageCode;
            this.imes.packageName = this.orderDetail.esimPackageName;
            this.imes.packagePrice = this.orderDetail.esimPricePackage;
            this.imes.isdnPrice = this.orderDetail.esimPriceIsdn;
            this.imes.totalAmount =
              this.orderDetail.esimPricePackage + this.orderDetail.esimPriceIsdn;
          }

          if (this.data) {
            this.imes.idNumber = this.data.idNumber;
            this.imes.fullName = this.data.fullName;
            this.imes.dob = this.data.dob;
          }
          if (this.profile) {
            this.imes.accountABA = this.profile.appId;
          }
          if (this.itemCCCD) {
            this.imes.transIdeKYC = this.itemCCCD.transid;
          } else if (this.itemPassport) {
            this.imes.transIdeKYC = this.itemPassport.transid;
          }

          if (this.data.imgCCCD && this.idType == 1) {
            this.base64ImgCCCD = this.data.imgCCCD.replace(
              /^data:image\/\w+;base64,/,
              ""
            );
            this.base64ImgFaceId = this.data.imgFaceId.replace(
              /^data:image\/\w+;base64,/,
              ""
            );
          } else if (
            this.data.imgPassport &&
            this.data.imgVisa &&
            this.idType == 3
          ) {
            this.base64ImgPassport = this.data.imgPassport.replace(
              /^data:image\/\w+;base64,/,
              ""
            );
            this.base64ImgVisa = this.data.imgVisa.replace(
              /^data:image\/\w+;base64,/,
              ""
            );
            this.base64ImgFaceId = this.data.imgFaceId.replace(
              /^data:image\/\w+;base64,/,
              ""
            );
          }

          if (this.detailPaymentInfo) {
            this.imes.orderCode = this.detailPaymentInfo.orderCode || "";
          }

          let mes = `<data>
            <merchantAccount>WING</merchantAccount>
            <partnerAccount>${this.profile.id}</partnerAccount>
            <paidIsdn>${this.imes.isdn}</paidIsdn>
            <transIdKyc>${this.imes.transIdeKYC}</transIdKyc>
            <idNumber>${this.imes.idNumber}</idNumber>
            <dob>${this.imes.dob}</dob> 
            <currency></currency>
            <fullName>${this.imes.fullName}</fullName>
            <packageCode>${this.imes.packageCode}</packageCode>
            <isKycFail>false</isKycFail>
            <accountABA>${this.imes.accountABA}</accountABA> 
            <packageName>${this.imes.packageName}</packageName>
            <packagePrice>${this.imes.packagePrice}</packagePrice>
            <isdnPrice>${this.imes.isdnPrice}</isdnPrice> 
            <idType>${this.idType}</idType>
            <orderCode>${this.imes.orderCode}</orderCode>
            <isEkyc>${this.isEkyc}</isEkyc>
            <totalAmount>${this.imes.totalAmount}</totalAmount>
          </data>`;

          console.log("mes --> prePayment", mes);

          let params = this.stateAsObject(this.defaultParam);
          const privateKeyPem = keyToPem(CONSTANTS.PRIVATE_KEY, "PRIVATE KEY");
          const publicKeyPem = keyToPem(CONSTANTS.PUBLIC_KEY, "PUBLIC KEY");
          params.signature = sign(mes, privateKeyPem);
          params.encrypt = encrypt(mes, publicKeyPem);

          if (this.idType == 1) {
            params.frontSide = this.base64ImgCCCD;
            params.portrait = this.base64ImgFaceId;
          } else {
            params.frontSide = this.base64ImgPassport;
            params.backSide = this.base64ImgVisa;
            params.portrait = this.base64ImgFaceId;
          }

          console.log("params ---> prePayment", params);

          // consosole.log("params", params);
          this.showLoading = true;
          await this.$store
            .dispatch("esimMetfoneStore/prePayment", params)
            .then((res) => {
              if (res) {
                let result = res.data;
                console.log("result", result);
                if (result && result.errorCode == 0 && result.buyESimInfo) {
                  const buyESimInfo = result.buyESimInfo
                  this.$store.dispatch("esimBuyStore/detailPaymentInfo", {
                    flowType: ESIM_ORDER_FLOW.BUY,
                    fullName: this.data.fullName,
                    gender: this.data.gender,
                    dob: this.data.dob,
                    province: this.data.province || "",
                    idNumber: this.data.idNumber,
                    phoneNumber: this.orderDetail.esimIsdn,
                    phoneNumberPrice: this.orderDetail.esimPriceIsdn,
                    packageCode: this.orderDetail.esimPackageCode,
                    packagePrice: this.orderDetail.esimPricePackage,
                    packageName: this.orderDetail.esimPackageName,
                    totalPrice: this.orderDetail.totalPrice,
                    transIdeKYC: this.imes.transIdeKYC,
                    idType: this.idType,

                    orderCode: buyESimInfo.orderCode || "",
                    orderStatus: buyESimInfo.orderorderStatusCode || "",
                    orderStatusName: buyESimInfo.orderStatusName || "",
                    orderTime: buyESimInfo.orderTime || "",
                    fee: buyESimInfo.fee || 0,
                    amount: buyESimInfo.amount || 0,
                    expireTime: buyESimInfo.expireTime || 0,

                    requestId: buyESimInfo.requestId, 
                    totalAmount: buyESimInfo.totalAmount || buyESimInfo.amount || 0,
                    isEkyc: this.isEkyc,
                    hashPayment: buyESimInfo.hashPayment,
                  });

                  if (flag == 1) {
                    this.$router.replace({ path: "/esim-payment" });
                  } else if (flag == 0) {
                    this.handleEKYCNavigation();
                  }
                } else {
                  this.$notify({
                    code: result.errorCode,
                    message: result.message,
                  });
                  // this.$toast(result.errorMessage);
                }
              }
            });
          this.showLoading = false;
        }
      }

    },
    // async handleContinuePayment() {
    //     if (this.isShowPay) {
    //         this.$router.replace({ path: "/esim-payment" });
    //     }
    // },
    // handleTryAgain() {
    //     this.$router.push({ path: "/register-infor" });
    // },

    handleEKYCNavigation() {
      if (this.idType == 1) {
        if (!this.statusCCCD) {
          this.$store.dispatch(
            "verificationInfoStore/setItemCCCD",
            null
          );
          this.$store.dispatch(
            "verificationInfoStore/setImgCCCD",
            null
          );

          this.$store.dispatch(
            "verificationInfoStore/setItemFaceId",
            null
          );
          this.$store.dispatch(
            "verificationInfoStore/setImgFaceId",
            null
          );

          this.$router.replace("/id-card#front-side");
        } else if (!this.statusFaceId) {
          this.$store.dispatch(
            "verificationInfoStore/setItemFaceId",
            null
          );
          this.$store.dispatch(
            "verificationInfoStore/setImgFaceId",
            null
          );

          this.$router.replace("/id-card#face-detect");
        }
      } else if (this.idType == 3) {
        if (!this.statusPassport) {
          this.$store.dispatch(
            "verificationInfoStore/setItemPassport",
            null
          );
          this.$store.dispatch(
            "verificationInfoStore/setImgPassport",
            null
          );

          this.$store.dispatch(
            "verificationInfoStore/setImgVisa",
            null
          );

          this.$store.dispatch(
            "verificationInfoStore/setItemFaceId",
            null
          );
          this.$store.dispatch(
            "verificationInfoStore/setImgFaceId",
            null
          );

          this.$router.replace("/passport#front-side");
        } else if (!this.statusFaceId) {
          this.$store.dispatch(
            "verificationInfoStore/setItemFaceId",
            null
          );
          this.$store.dispatch(
            "verificationInfoStore/setImgFaceId",
            null
          );

          this.$router.replace("/passport#face-detect");
        }
      }
    }
  },
};
</script>
<style>
.detail-payment-pages {
  background-color: #fff !important;
  min-height: 100vh;
}

.list-detail-payment.van-hairline--top-bottom::after {
  border-top: 0 !important;
}

.list-detail-payment .van-cell {
  padding: 8px 0px !important;
}

.list-detail-payment .van-cell:last-child::after {
  border-bottom: none !important;
}

.img-id-card {
  width: auto;
  height: 100px;
  object-fit: contain;
  border-radius: 8px;
}

.img-faceid {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
}

.border-success {
  border: 2px solid #00ba00 !important;
}

.border-danger {
  border: 2px solid #f74750 !important;
}
</style>
